const Heading = {
  baseStyle: {
    fontWeight: 'normal',
  },
  variants: {
    lg_normal: {
      fontWeight: 700,
      fontSize: '20px',
      lineHeight: '120%',
    },
    md_bold: {
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '120%',
    },
    md_normal: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '150%',
    },
    sm_semibold: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '150%',
    }
  },
  defaultProps: {
    variant: 'bold_lg',
  },
};
  
export default Heading;
  